export default __webpack_public_path__ + "static/media/terms_and_conditions.68ecb773.pdf";